import { Component, ElementRef, Input, NgZone, OnInit } from '@angular/core';
import {
  getMprdProductType,
  getPriceForTrialOption,
  hasWebdeal,
  isActiveTrialOption,
  isAsOrAsasOption,
  isEligibleFavoriteContent,
  isHighestActiveFavoriteContent,
  isOptionActive,
  isResCustomer,
  NetflixBuyAndSellStatus,
  Option,
  OptionType,
  Product,
  TvProduct,
} from '@dch/products-business-logic';
import { OnDestroyHookDirective } from '../../../shared/hooks';
import {
  CustomerService,
  InceptionService,
  LanguageService,
  TranslationService,
} from '@proximus/ng-common';
import { savePii, savePiiBrand } from '../../../shared/pii/pii.utils';
import { WebshopUtils } from '../../../shared/webshop/webshop-utils';
import {
  getAlertKey,
  hasAsOrAsasActive,
  isPending,
} from '../../../shared/order-utils/order-utils';
import { Router } from '@angular/router';

@Component({
  selector: 'mprd-option',
  templateUrl: './option.component.html',
})
export class OptionComponent extends OnDestroyHookDirective implements OnInit {
  OptionType = OptionType;

  @Input() option: Option;
  @Input() product: Product;
  @Input() selectedCategory: string;
  @Input() optionType: OptionType = OptionType.OPTION;
  @Input() activeTvBonus: Option;
  @Input() isConfigurableOption: boolean;
  @Input() isUnmigratedTvCustomer: boolean;

  active: boolean;
  hasWebdeal: boolean;
  showActiveTvBonusMessage: boolean;
  showEligibleTvBonusMessage: boolean;
  isRes: boolean;
  priceTrialOption = '';
  isActiveTrialOption: boolean;
  productType: string;
  showNetflixBSWarning: boolean;
  showDisneyPlusBSWarning: boolean;
  isEBU: boolean;
  optionClickedEvent: any;
  isAsOrAsasOptionPromo = false;

  savePii = savePii;

  isPendingInCart: boolean;
  pendingOrder: boolean;
  private isSubscribed = false;
  optionCategoryImageClass = '';

  constructor(
    private customerService: CustomerService,
    private ngZone: NgZone,
    private router: Router,
    private languageService: LanguageService,
    private translationService: TranslationService,
    private element: ElementRef,
    private inceptionService: InceptionService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.addSubscription(
      this.customerService.getCustomerAccount().subscribe((value) => {
        this.isRes = isResCustomer(value);
        this.priceTrialOption = getPriceForTrialOption(
          this.option,
          this.isRes,
        ).toString();
        this.isActiveTrialOption = isActiveTrialOption(this.option);
        this.isEBU = value.isEBU();
        if (this.isEBU === false) {
          this.subscribeToWebshopEvents();
        }
      }),
    );
    this.active = this.option && isOptionActive(this.option);
    this.showActiveTvBonusMessage = isHighestActiveFavoriteContent(
      this.option,
      this.activeTvBonus,
    );
    this.showEligibleTvBonusMessage = isEligibleFavoriteContent(
      this.product as any,
      this.option,
      this.activeTvBonus,
    );
    this.hasWebdeal = this.option && hasWebdeal(this.option);
    this.isAsOrAsasOptionPromo =
      isAsOrAsasOption(this.option) &&
      this.translationService.getTranslatedValueFor(
        'tv.option.patch.showPromo',
      ) === 'true';
    this.productType = getMprdProductType(this.product);

    this.optionClickedEvent = {
      event_detail: this.product.productDescription + ':view option',
      event_location: this.productType + '.options',
      event_action: 'click',
    };
    this.showNetflixBSWarning =
      !!(this.product as TvProduct).netflixBuyAndSell &&
      (this.product as TvProduct).netflixBuyAndSell ===
      NetflixBuyAndSellStatus.NOT_ELIGIBLE &&
      this.option.optionCodeForDescription === 'MKIWR';

    this.showDisneyPlusBSWarning =
      (this.option.optionCodeForDescription === 'PELYC' || this.option.optionCodeForDescription === 'DJMHG') &&
      hasAsOrAsasActive(this.product);

    if (this.option.optionCategoryImage) {
      this.optionCategoryImageClass =
        '[' +
        this.option.optionCategoryImage.small +
        ', (default)],[' +
        this.option.optionCategoryImage.medium +
        ', (medium)],[' +
        this.option.optionCategoryImage.large +
        ', (large)]';
      setTimeout(() => {
        this.inceptionService.init();
      });
    }
  }

  getAlertKey(): string {
    return getAlertKey(undefined, this.option);
  }

  private subscribeToWebshopEvents() {
    if (!this.isSubscribed) {
      this.isSubscribed = true;
      WebshopUtils.subscribeToCartEvent((data: any) => {
        this.ngZone.run(() => {
          if (data.status === 'PENDING_ORDER') {
            this.pendingOrder = isPending(this.product, this.option, false);
          } else if (data.status === 'LOADED') {
            this.pendingOrder = isPending(this.product, this.option, false);
            if (data.products.length !== 0) {
              const find = data.products.find(
                (p: any) => p.mpcUuid === this.option.optionCodeForDescription,
              );
              this.isPendingInCart = !!find;
            } else {
              this.isPendingInCart = false;
            }
          }
        });
      }, this.addSubscription);
    }
  }

  handleClick() {
    if (this.option.optionCodeForDescription === 'STREAMZ') {
      const url =
        this.option?.redirectLink?.url[
        this.languageService.getSelectedLanguage()
        ];
      window.open(url, '_blank');
    } else {
      savePii(this.product?.accessNumber);
      savePiiBrand(this.product?.brand);
      this.router.navigate([
        '/details/option/',
        this.option?.optionCodeForDescription || '',
        this.productType,
      ],
        {
          queryParams: this.isUnmigratedTvCustomer ? { old: true } : {},
        }
      );
    }
  }
}
